module.exports = __webpack_public_path__ + "media/favicon/mstile-310x310-433ddce8d0372499e1055e7e02581e02.png";